import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { storeWriteSettingsAdapts } from './store-write-settings.adapter';
import { GoogleCloudStorageWriteSettings } from 'app/model/pipeline/copysink/store-write-settings/google-cloud-storage-store-write-settings';
import { AmazonS3WriteSettingsAdapter } from './amazon-s3-store-write-settings.adapter';

@AdapterRegistry.adapter({
    model:  Metamodel.modelFor(GoogleCloudStorageWriteSettings),
    asynchronous: true,
    adapts: {
        ...storeWriteSettingsAdapts
    }
})

export class GoogleCloudStorageWriteSettingsAdapter extends AmazonS3WriteSettingsAdapter {}
